export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-folder-lock-f1dde91b5b275d1e18cdfc79d29e8822.svg";